import type { LngLatEntity } from "@/shared/entities/LngLatEntity";

export class DistrictMiniEntity {
    id?: number;
    name?: string | null;
    boundary?: Array<LngLatEntity> | null;
    numberOfBranches?: number;
    createdAt?: string;
    updatedAt?: string;
    disabled?: boolean;
}
